import { c as _c } from "react/compiler-runtime";
import { formatNumber } from "@/utils/format";
import { killfeed } from "..";
export default function StatsTable() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-5 flex-wrap justify-center w-full"><DeathsTable /><UniqueTable /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function DeathsTable() {
  const $ = _c(9);
  const logCount = killfeed.logs.length;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = killfeed.logs.filter(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const pvpLogCount = t0.length;
  const pvpLogPercentage = Math.round(100 / logCount * pvpLogCount);
  const pveLogCount = logCount - pvpLogCount;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Math.round(100 - pvpLogPercentage);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pveLogPercentage = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <thead><tr className="border-b"><th className="p-1.5 h-10 bg-neutral-900" colSpan={2}>Deaths</th></tr></thead>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <th className="p-1.5">PvP</th>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <tr className="hover:bg-neutral-900/50 border-b">{t3}<td className="p-1.5 border-l text-center">{formatNumber(pvpLogCount)} ({pvpLogPercentage}%)</td></tr>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <th className="p-1.5">PvE</th>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <tbody>{t4}<tr className="hover:bg-neutral-900/50 border-b">{t5}<td className="p-1.5 border-l text-center">{formatNumber(pveLogCount)} ({pveLogPercentage}%)</td></tr></tbody>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <th className="p-1.5">Total</th>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="rounded overflow-hidden border"><table className="w-full">{t2}{t6}<tfoot><tr className="hover:bg-neutral-900/50">{t7}<td className="p-1.5 border-l text-center">{formatNumber(logCount)}</td></tr></tfoot></table></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}
function _temp(t0) {
  const {
    pvp
  } = t0;
  return pvp;
}
function UniqueTable() {
  const $ = _c(7);
  const playerCount = killfeed.playerNames.length - 1;
  const weaponCount = killfeed.weaponNames.length - 1;
  const objectCount = killfeed.objectNames.length - 1;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <thead><tr className="border-b"><th className="p-1.5 h-10 bg-neutral-900" colSpan={2}>Unique</th></tr></thead>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <th className="p-1.5">Player names</th>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <tr className="hover:bg-neutral-900/50 border-b">{t1}<td className="p-1.5 border-l text-center">{formatNumber(playerCount)}</td></tr>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <th className="p-1.5">Killing tools</th>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <tr className="hover:bg-neutral-900/50 border-b">{t3}<td className="p-1.5 border-l text-center">{formatNumber(weaponCount)}</td></tr>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <th className="p-1.5">Other shit people died to</th>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div><div className="rounded overflow-hidden border"><table className="w-full">{t0}<tbody>{t2}{t4}<tr className="hover:bg-neutral-900/50">{t5}<td className="p-1.5 border-l text-center">{formatNumber(objectCount)}</td></tr></tbody></table></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}